import React from 'react';

const SummationForm = ({ value1, value2, onSetAnswer, answer, register, error }) => {
  return (
    <div>
      <label className="block mb-1 font-medium text-gray-900 text-left">Pengaman</label>
      <div className="flex">
        <span className="border border-gray-300 text-gray-900 rounded-l-lg focus:ring-blue-300 focus:border-blue-300 block p-2.5">
          {value1} + {value2} =
        </span>
        <input
          name="answer"
          onChange={(e) => onSetAnswer(e.target.value)}
          value={answer}
          className="border border-gray-300 text-gray-900 rounded-r-lg focus:ring-blue-300 focus:border-blue-300 block p-2.5"
          type="number"
          placeholder="Jawaban"
          {...register}
        />
      </div>
      {error && <p className="text-red-500 text-left mt-1">{error.message}</p>}
    </div>
  );
};

export default SummationForm;
